export const TIPO_IMPUESTO_EMPRESA_ENUM = {
  COMPRA: 0,
  VENTA: 1,
  OTRO: 2,
} as const

export type TipoImpuestoEmpresaEnumType =
  (typeof TIPO_IMPUESTO_EMPRESA_ENUM)[keyof typeof TIPO_IMPUESTO_EMPRESA_ENUM]
